var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.4995V2.49948C0 1.39636 0.896484 0.499481 2 0.499481H14C15.1035 0.499481 16 1.39636 16 2.49948V14.4995C16 15.6026 15.1035 16.4995 14 16.4995H2C0.896484 16.4995 0 15.6026 0 14.4995ZM14 14.4995V2.49948H2V14.4995H14ZM11.5 10.4995C12.1875 10.4995 12.1562 9.49948 11.5 9.49948H4.5C3.84375 9.49948 3.84375 10.4995 4.5 10.4995H11.5ZM9.5 12.4995H4.5C3.8125 12.4995 3.84375 11.4995 4.5 11.4995H9.5C10.125 11.4995 10.1875 12.4995 9.5 12.4995ZM10 7.49948C11.1045 7.49948 12 6.60406 12 5.49948C12 4.3949 11.1045 3.49948 10 3.49948C8.89551 3.49948 8 4.3949 8 5.49948C8 6.60406 8.89551 7.49948 10 7.49948ZM6 3.49948L4 7.49948H8L6 3.49948Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.f0366fd4a929c8b64ec2375cf6f0d8bd.svg";
export { ForwardRef as ReactComponent };